export default __webpack_public_path__ + "static/media/cpv_22_press.6dbbaa88.svg";